import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'ng-hbm-bdi-btn',
  templateUrl: './btn.component.html'
})
export class BtnComponent implements OnInit {

  @HostBinding("class.isLoading") get isLoading() { return this.loading };
  @HostBinding("class.disabled") get isDisabled() { return this.disabled };

  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() label: string;

  ngOnInit(): void { }

  disabledAreaClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
  }
}
